import React, { useState, useEffect } from 'react'
import { getQuidEquifaxById } from '../../AdminActionCreator.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import { Check, Copy } from 'lucide-react';
import NoData from '../../../../../images/nodata.png'

export default function EquifaxCrifQuid({ admin, userdata, hnadleEquifaxOpenPopup }) {
    const now = new Date();

    const month = now.toLocaleString('en-US', { month: 'short' }); // e.g. "May"
    const year = now.getFullYear(); // e.g. 2026

    // const passwrod = `11148${month}${year}`;
    const passwrod = "11148Jul2026";
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState({})
    const [handlecopy, sethandlecipy] = useState(false)

    useEffect(() => { APi() }, [])

    const APi = () => {
        setLoader(true)
        getQuidEquifaxById(userdata?.userId, admin?.emailId, callback => {
            setLoader(false)
            setData(callback)
        })
    }

    const hnadleCopy = () => {
        navigator.clipboard.writeText(passwrod)
        sethandlecipy(true)
        setTimeout(() => {
            sethandlecipy(false)
        }, 2000)

    }
    return (
        <>
            <div className="background-blur">

                <div className="popup-main small-popup container-fluid dbl-border " style={{ padding: '20px', borderRadius: '10px', maxWidth: '90%', width: "100%" }}>
                    {loader ? <Loader /> : ""}
                    <i onClick={() => hnadleEquifaxOpenPopup(false)} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                    <div className="row from-group">
                        <div className="col-xs-12" style={{ padding: '10px' }}>
                            <h4 className="text-center" style={{ marginTop: '10px' }}>Equifax Soft Approval</h4>
                            <div className="" style={{ marginTop: '10px', textAlign: 'end' }}>
                                <h5 style={{ border: '1px solid #eee', borderRadius: '6px', display: 'inline-flex', marginLeft: 'auto', padding: '7px', background: 'green', color: '#fff', alignItems: 'center', cursor: 'pointer' }} onClick={() => hnadleCopy()}>Password: {passwrod}
                                    <div>
                                        {
                                            handlecopy ?
                                                <Check style={{ color: '#fff', marginLeft: '5px', cursor: 'pointer', width: '12px', height: '12px' }} />
                                                :
                                                <Copy style={{ color: '#fff', marginLeft: '5px', cursor: 'pointer', width: '12px', height: '12px' }} />

                                        }
                                    </div>
                                </h5>
                            </div>
                        </div>
                        {
                            data?.url ?
                                <div className="col-xs-12" style={{ padding: '10px' }}>
                                    <iframe src={data?.url ?? ""} height={"500px"} width={"100%"} />
                                </div>
                                :
                                <div className='text-center'>
                                    <img src={NoData} width={"30%"} />
                                </div>
                        }
                    </div>

                </div>
            </div>
        </>
    )
}
